import { useAnchorName as e, usePopover as t } from "../../hooks/useAnchoredPopover.js";
import { forwardRef as n, useRef as r } from "react";
import { isEmpty as i } from "es-toolkit/compat";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/applicationHeader/CollapsedNavItem.tsx
var s = n((n, s) => {
	let { show: c = !1, navItems: l, actionBarItems: u, onDropdownClick: d, onItemClick: f } = n, p = r(null), m = e("application-header-collapsed");
	if (t(p, c), i(l) && i(u)) return null;
	let h = c ? "open" : "", g = { anchorName: m }, _ = { positionAnchor: m };
	return /* @__PURE__ */ o("li", {
		className: `CollapsedDropdown dropdown ${h}`,
		ref: s,
		style: g,
		children: [/* @__PURE__ */ a("a", {
			id: "basic-nav-dropdown",
			role: "button",
			className: "dropdown-toggle text-color-gray",
			"aria-haspopup": "true",
			"aria-expanded": "true",
			onClick: d,
			children: /* @__PURE__ */ a("span", {
				className: "uikit-icon icon-option-horizontal",
				"aria-hidden": "true"
			})
		}), /* @__PURE__ */ a("ul", {
			popover: "manual",
			className: "dropdown-menu",
			role: "menu",
			"aria-labelledby": "basic-nav-dropdown",
			ref: p,
			style: _,
			children: l.map((e) => /* @__PURE__ */ a("li", {
				className: "submodule",
				onClick: f,
				"data-nav-item-key": e.key,
				children: e.route
			}, e.key))
		})]
	}, "collapsed-dropdown");
});
//#endregion
export { s as default };

//# sourceMappingURL=CollapsedNavItem.js.map